module.exports = __webpack_public_path__ + "img/token_desk.77e681f7.png";